import { call, put, takeEvery } from 'redux-saga/effects';
import { checkPermission } from '../../requests/check_permission_request';
import { checkPermissionForFieldRequestSuccess } from '../actions/check_permission.actions';
import { CHECK_PERMISSION_FOR_FIELD_REQUEST } from '../constants/check_last_route_and_permission.constants';

function* checkPermissionForFieldRequest({ urls }) {
    const checked_urls = {};
    let url;
    for (url of urls) {
        const { msg } = yield call(checkPermission, url);
        checked_urls[url] = msg === 'Access granted';
    }
    yield put(checkPermissionForFieldRequestSuccess(checked_urls));
}

export default function* checkPermissionForFieldSaga() {
    yield takeEvery(CHECK_PERMISSION_FOR_FIELD_REQUEST, checkPermissionForFieldRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/check_permission_for_field.saga.js